import Aboutsoc from '../Components/Aboutsoc';
import LastYear from '../Components/lastyear';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';

function About(){
    return(
        <div className="overflow-hidden">
            <Navbar/>
            <Aboutsoc/>
            <LastYear/>
            <Footer />
        </div>
    )
}

export default About;